import styled from "styled-components"

export const Home = styled.div`
  width: 100%;
  height: 100%;
  background-color: navajowhite;
`
